import { useRegisterSW } from 'virtual:pwa-register/react'

export default function ReloadPrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisterError(error) {
      console.error('Service worker registration failed:', error)
    },
  })

  if (!needRefresh) return null

  return (
    <div className="fixed bottom-4 right-4 z-[100] max-w-sm rounded-lg border border-gray-200 bg-white shadow-lg p-4">
      <p className="text-sm font-medium text-gray-900">A new version is available</p>
      <p className="text-xs text-gray-500 mt-0.5">
        Reload to get the latest. Anything unsaved will be lost.
      </p>
      <div className="mt-3 flex justify-end gap-2">
        <button
          onClick={() => setNeedRefresh(false)}
          className="px-3 py-1.5 text-xs font-medium rounded-md border border-gray-300 text-gray-700 hover:bg-gray-50"
        >
          Later
        </button>
        <button
          onClick={() => void updateServiceWorker(true)}
          className="px-3 py-1.5 text-xs font-medium rounded-md bg-primary text-white hover:bg-primary/90"
        >
          Reload
        </button>
      </div>
    </div>
  )
}
